<div
  *ngIf="searchString.length === 0 && isMobile"
  class="mobile-top-padding-live-transmissions"
></div>
<div
  *ngIf="searchString.length !== 0 && isMobile"
  class="mobile-top-padding"
></div>
<app-live-transmissions
  *ngIf="searchString.length === 0 && !isMobile"
></app-live-transmissions>

<div class="filters-container">
  <div class="search-container" *ngIf="!isMobile">
    <div>
      <input
        type="text"
        class="search-field"
        placeholder="Buscar"
        [(ngModel)]="currentFilter.search"
        (input)="onSearchInputChange($event)"
      />
      <i class="bi bi-search search-field__icon"></i>
    </div>
  </div>

  <div class="search-mobile-container" *ngIf="isMobile">
    <div class="search-mobile-box">
      <i class="bi bi-search search-mobile-icon"></i>
      <input
        type="text"
        class="search-mobile-field"
        placeholder="Busque pelo Título, Assunto ..."
        [(ngModel)]="currentFilter.search"
        (input)="onSearchInputChange($event)"
      />
      <i class="bi bi-funnel search-mobile-filter"></i>
    </div>
  </div>
</div>

<div
  *ngIf="videos.length !== 0 && searchString.length !== 0 && !isSearchLoading"
  class="result-container"
>
  <h2 class="result-text">
    Exibindo
    <span class="result-span">{{ videos.length }} resultados</span> para
    <span class="result-span">{{ searchString }}</span>
  </h2>
</div>

<div *ngIf="isSearchLoading" class="search-loading-wrapper">
  <app-generic-loading [isLoading]="true"></app-generic-loading>
</div>

<div
  *ngIf="videos.length === 0 && searchString.length > 0 && !isSearchLoading"
  class="placeholder search-results-wrapper"
>
  <img
    class="placeholder-img"
    src="assets/images/videos-placeholder.svg"
    alt="placeholder"
  />
</div>

<ng-container
  *ngIf="videos.length !== 0 && searchString.length !== 0 && !isSearchLoading"
  class="search-results-wrapper"
>
  <div class="video-cards-list">
    <app-video-list-card
      *ngFor="let video of videos"
      class="video-card"
      [video]="video"
    ></app-video-list-card>
    <div
      *ngFor="let item of emptyVideoCards"
      class="video-card"
      [style.cursor]="'auto'"
    ></div>
  </div>
  <p-paginator
    class="pagination-component"
    [paginatorVersion]="2"
    [currentPage]="searchCurrentPage"
    [maxRowsPerPage]="searchPageSize"
    [totalRows]="searchTotalCount"
    (currentPageChange)="onSearchPageChange($event)"
  ></p-paginator>
</ng-container>

<div
  *ngIf="videos && searchString.length === 0"
  class="videos-and-events-container"
>
  <div class="video-listing-container">
    <ng-container *ngIf="!isLoadingCategories; else loading">
      <app-category-videos-swiper
        *ngFor="let category of categories; let i = index"
        [category]="category"
        [index]="i"
        [isLastOfPage]="i === categories.length - 1"
        [parentComponentItems]="
          showLiveTransmissionsCategory &&
          category.id === liveTransmissionCategoryId
            ? liveTransmissionCategoryItems
            : []
        "
      >
      </app-category-videos-swiper>
    </ng-container>
    <p-paginator
      class="pagination-component"
      [paginatorVersion]="2"
      [currentPage]="currentPageCategories"
      [maxRowsPerPage]="pageSizeCategories"
      [totalRows]="totalCountCategories"
      (currentPageChange)="onPageChange($event)"
    ></p-paginator>
  </div>
</div>

<ng-template #loading>
  <div *ngIf="!checkIfMainCarouselIsLoading()" class="loading-categories">
    <div class="loading-wrapper">
      <app-generic-loading [isLoading]="true"></app-generic-loading>
    </div>
  </div>
</ng-template>
